var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8333V3.83325C3 3.30282 3.21071 2.79411 3.58579 2.41904C3.96086 2.04397 4.46957 1.83325 5 1.83325H12.3333C12.5101 1.83325 12.6797 1.90349 12.8047 2.02851C12.9298 2.15354 13 2.32311 13 2.49992V10.8333H4.91667M3 10.8299V12.4166",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 14.1666H4.66667C4.22464 14.1666 3.80072 13.991 3.48816 13.6784C3.17559 13.3659 3 12.9419 3 12.4999C3 12.0579 3.17559 11.634 3.48816 11.3214C3.80072 11.0088 4.22464 10.8333 4.66667 10.8333H13V13.4999C13 13.6767 12.9298 13.8463 12.8047 13.9713C12.6797 14.0963 12.5101 14.1666 12.3333 14.1666Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 7.99994V4.02661H10.0668V7.99994H9.4375Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39258 7.99994L6.78991 4.02661H7.56858L8.96591 7.99994H8.29391L7.98991 7.10928H6.37391L6.06458 7.99994H5.39258ZM6.55524 6.54928H7.79791L7.09391 4.46928H7.26991L6.55524 6.54928Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyIcon);
export default __webpack_public_path__ + "static/media/policyIcon.8e724dae72f6e76cce1b44ae1a59e03d.svg";
export { ForwardRef as ReactComponent };